export default __webpack_public_path__ + "static/media/Bestand.eb3d6507.svg";